import React, { useContext, useEffect, useState } from 'react';
import { Button, Card, Col, Dropdown, Row,Form } from 'react-bootstrap';
import Flex from 'components/common/Flex';
import Avatar from 'components/common/Avatar';
import team1 from 'assets/img/team/1.jpg';
import { submitFeedback } from 'functions/ticket';
import { toastMessageBox } from './ToastifyMessage';

// const CreatePostForm = ({ticketMasterId}) => {

//     const [feedback, setFeedback] = useState('');
  
//     return (
//       <Form>

//         <Form.Control
//           as="textarea"
//           rows={4}
//           placeholder="What do you want to tell us?"
//           className="shadow-none rounded-0 resize-none border-y-0 px-x1 border-200"
//           value={status}
//           onChange={e => setFeedback(e.target.value)}
//         />

//      <Row>
//         <Col className="g-0 mt-3 px-x1 pb-3">
//         <SmileyMarker feedback={feedback} ticketMasterId={ticketMasterId} /> 
//         </Col>
//      </Row>
//       </Form>
//     );
//   };



const SmileyMarker = ({ handleSubmit }) => {
  const [rating, setRating] = useState('');

  const handleSmileyClick = (smileyIndex) => {
    setRating(smileyIndex);
  };

  const smileyOptions = [
    { index: 1, mood: 'Terrible', emoji: '😞' },
    { index: 2, mood: 'Below Expectations', emoji: '😐' },
    { index: 3, mood: 'Average', emoji: '🙂' },
    { index: 4, mood: 'Above Expectations', emoji: '😊' },
    { index: 5, mood: 'Outstanding', emoji: '😃' }
  ];

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', margin: '20px' }}>
        <h4>Your Feedback?</h4>
      </div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', margin: '20px',marginLeft:'100px',marginRight:'100px' }}>
        <div style={{ textAlign: 'center', flex: '1',display: 'flex', justifyContent: 'space-between' }}>
          {smileyOptions.map((smiley) => (
            <div key={smiley.index}>
              <span
                onClick={() => handleSmileyClick(smiley.index)}
                style={{
                  cursor: 'pointer',
                  fontSize: smiley.index === rating ? '40px' : '30px',
                  marginRight: '5px',
                  color: smiley.index <= rating ? 'gold' : 'gray',
                }}
              >
                {smiley.emoji}
              </span>
              <p>{smiley.mood}</p>
            </div>
          ))}
        </div>
      </div>
      <div style={{ display: 'flex', justifyContent: 'center', marginTop: '20px' }}>
        <Button size="large" className="px-4 px-sm-5" type="button" onClick={() => handleSubmit(rating)}>
          Submit
        </Button>
      </div>
    </div>
  );
};

  // const SmileyMarker = ({handleSubmit}) => {
  //   const [rating, setRating] = useState('');
  
  //   const handleSmileyClick = (smileyIndex) => {
  //     setRating(smileyIndex);
  //   };

  //   useEffect(()=>{
    
  //   },[rating]);
  
  //   const getRatingLabel = () => {
  //     switch (rating) {
  //       case 1:
  //         return 'Terrible';
  //       case 2:
  //         return 'Below Expectations';
  //       case 3:
  //         return 'Average';
  //       case 4:
  //         return 'Above Expectations';
  //       case 5:
  //         return 'Outstanding';
  //       default:
  //         return '';
  //     }
  //   };
  

  
  //   return (
  //     <div>
  //       <div style={{ display: 'flex', justifyContent: 'space-between', margin: '20px' }}>
  //         <h4>Your Feedback?</h4>
  //         <div style={{ textAlign: 'center', flex: '1' }}>
  //           {[
  //             { index: 1, mood: 'Terrible', emoji: '😞' },
  //             { index: 2, mood: 'Below Expectations', emoji: '😐' },
  //             { index: 3, mood: 'Average', emoji: '🙂' },
  //             { index: 4, mood: 'Above Expectations', emoji: '😊' },
  //             { index: 5, mood: 'Outstanding', emoji: '😃' }
  //           ].map((smiley) => (
  //             <span
  //               key={smiley.index}
  //               onClick={() => handleSmileyClick(smiley.index)}
  //               style={{
  //                 cursor: 'pointer',
  //                 fontSize: smiley.index === rating ? '40px' : '30px',
  //                 marginRight: '5px',
  //                 color: smiley.index <= rating ? 'gold' : 'gray',
  //               }}
  //             >
  //               {smiley.emoji}
  //             </span>
  //           ))}
  //         </div>
  //         <div style={{ textAlign: 'right', flex: '1' }}>
  //           <p style={{ fontSize: '20px', marginTop: '10px' }}>{getRatingLabel()}</p>
  //         </div>
  //       </div>
  //       <div style={{ display: 'flex', justifyContent: 'center' }}>
  //         <Button size="large" className="px-4 px-sm-5" type="button" onClick={()=>handleSubmit(rating)}>
  //           Submit
  //         </Button>
  //       </div>
  //     </div>
  //   );
  // };

const StarMarker = () => {
  const [rating, setRating] = useState(0);

  const handleStarClick = (starIndex) => {
    setRating(starIndex + 1);
  };

  return (
    <div>
 
      <div>
        {[1, 2, 3, 4, 5].map((starIndex) => (
          <span
            key={starIndex}
            onClick={() => handleStarClick(starIndex)}
            style={{
              cursor: 'pointer',
              color: starIndex < rating ? 'gold' : 'gray',
              fontSize: '30px',
            }}
          >
            &#9733;
          </span>
        ))}
      </div>
      <p>Selected Rating: {rating}</p>
    </div>
  );
};




const CustomerReview = ({ ticketMasterId,onsubmitLoad }) => {

const [feedback, setFeedback] = useState('');
const [isFeedbackSubmittedd, setIsFeedbackSubmittedd] = useState(false);

useEffect(()=>{
  onsubmitLoad() 
},[isFeedbackSubmittedd])


const handleSubmit = (rating) => {
    // Handle submission logic here
      const data= {ticketMasterId,feedback,rating};

      const token = localStorage.getItem('token');
      submitFeedback(data, token)
        .then(res => {
          const {outputMessage,responseStatus}=res.data.output;
          console.log('Feedback outputMessage:', outputMessage);
          if(responseStatus==="failed"){
            toastMessageBox("Exception",outputMessage,"warning");
            return;
          }
          console.log('Feedback Submitted:', rating);
          setIsFeedbackSubmittedd(true);
          toastMessageBox("Successful",outputMessage,"success");
        })
        .catch(err => {
          console.log('Error: ', err);
        });

  };


  return (
    <Card>
      <Card.Header className="bg-light">
        <Flex alignItems="center">
          <Avatar size="m" src={team1} />
          <div className="flex-1 ms-2">
            <h5 className="mb-0 fs-0">Leave a Feedback</h5>
          </div>
        </Flex>
      </Card.Header>
      <Card.Body className="p-0">

    <Form>

      <Form.Control
        as="textarea"
        rows={4}
        placeholder="What do you want to tell us?"
        className="shadow-none rounded-0 resize-none border-y-0 px-x1 border-200"
        value={feedback}
        onChange={e => setFeedback(e.target.value)}
      />

   <Row>
      <Col className="g-0 mt-3 px-x1 pb-3">
      <SmileyMarker feedback={feedback} ticketMasterId={ticketMasterId} handleSubmit={handleSubmit} /> 
      </Col>
   </Row>
    </Form>


      </Card.Body>
    </Card>
  );
};

export default CustomerReview;
